import { serializeError } from 'serialize-error';
import { ApiErrorType } from '@typings/common';
import { API_ERROR_NAME, API_ERROR_DEFAULT_CODE, API_ERROR_DEFAULT_MESSAGE } from './constants';

export class ApiError<T> extends Error {
    public readonly code: string;
    public readonly message: string;
    public readonly name: string;
    public readonly errors?: T | unknown;
    public readonly additionalErrors: { [key: string]: string };

    public constructor(message?: string, code?: string, errors?: T, additionalErrors = {}) {
        super(message);

        this.name = API_ERROR_NAME;
        this.message = message ?? API_ERROR_DEFAULT_MESSAGE;
        this.code = code ?? API_ERROR_DEFAULT_CODE;
        this.errors = errors ?? [];
        this.additionalErrors = additionalErrors;
    }

    public toJSON() {
        return serializeError(this) as ApiErrorType<T>;
    }
}
